import { hash } from "@ember/helper";
import DropdownSelectBox from "discourse/select-kit/components/dropdown-select-box";
import SearchFieldCombobox from "./combobox";
import SearchFieldWireFrame from "./wire-frame";

export default class SearchFieldDropdown extends SearchFieldCombobox {
  get none() {
    return this.args.none || { name: this.noneLabel };
  }

  <template>
    <SearchFieldWireFrame
      ...attributes
      @controller={{@controller}}
      @filter={{@filter}}
      @value={{@value}}
    >
      <DropdownSelectBox
        name={{@filter.name}}
        @nameProperty={{@nameProperty}}
        @valueProperty={{@valueProperty}}
        @value={{@value}}
        @content={{this.content}}
        @options={{hash none=this.none showCaret=true}}
      />
    </SearchFieldWireFrame>
  </template>
}
